// extracted by mini-css-extract-plugin
export default {"form":"MoveDialogForm-module__form--uULos","autoComplete":"MoveDialogForm-module__autoComplete--M1Njp","datePickerAnchor":"MoveDialogForm-module__datePickerAnchor--CXHl5"};